export default __webpack_public_path__ + "static/media/fashion.a81c5366.jpg";